import { enhancedApi } from './generated/cmsImportsService';

export const cmsImportsApiClient = enhancedApi.enhanceEndpoints({
  endpoints: {
    cmsImportList: {
      providesTags: (result) => {
        const items = result?.results ?? [];
        if (items.length === 0) {
          return [{ type: 'cms_import', id: 'LIST' }];
        }
        return [
          { type: 'cms_import', id: 'LIST' },
          ...items.map((cmsImport) => ({
            type: 'cms_import' as const,
            id: String(cmsImport.id),
          })),
        ];
      },
    },
    cmsImportRetrieve: {
      providesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: String(arg.id) },
      ],
    },
    cmsImportCreate: {
      invalidatesTags: () => [{ type: 'cms_import', id: 'LIST' }],
      query: (queryArg) => {
        const formData = new FormData();
        formData.append('firm_id', queryArg.body.firm_id);
        formData.append('cms_type', queryArg.body.cms_type);
        formData.append('file', queryArg.body.file);

        return {
          url: `/api/cms-imports/`,
          method: 'POST',
          body: formData,
        };
      },
    },
    cmsImportFilterOptions: {
      providesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: `filter-options:${String(arg.id)}` },
      ],
    },
    cmsImportCases: {
      providesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: `cases:${String(arg.id)}` },
      ],
    },
    cmsImportCasesMissingMatters: {
      providesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: `cases-missing:${String(arg.id)}` },
      ],
    },
    cmsImportTasks: {
      providesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: `tasks:${String(arg.id)}` },
      ],
    },
    cmsImportMatchingProgress: {
      providesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: `progress:${String(arg.id)}` },
      ],
    },
    cmsImportReplicate: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: String(arg.id) },
        { type: 'cms_import', id: `cases:${String(arg.id)}` },
        { type: 'cms_import', id: `tasks:${String(arg.id)}` },
        { type: 'cms_import', id: `filter-options:${String(arg.id)}` },
        { type: 'cms_import', id: `progress:${String(arg.id)}` },
      ],
    },
    cmsImportUpdateFilters: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: String(arg.id) },
        { type: 'cms_import', id: `tasks:${String(arg.id)}` },
        { type: 'cms_import', id: `cases-missing:${String(arg.id)}` },
      ],
    },
    cmsImportUpdateCaseMatch: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: `cases:${String(arg.id)}` },
        { type: 'cms_import', id: `cases-missing:${String(arg.id)}` },
        { type: 'cms_import', id: `progress:${String(arg.id)}` },
      ],
    },
    cmsImportBulkUpdateMatches: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: `cases:${String(arg.id)}` },
        { type: 'cms_import', id: `cases-missing:${String(arg.id)}` },
        { type: 'cms_import', id: `progress:${String(arg.id)}` },
      ],
    },
    cmsImportIngest: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: String(arg.id) },
        { type: 'cms_import', id: 'LIST' },
      ],
    },
    cmsImportDeleteCreatedTasks: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'cms_import', id: String(arg.id) },
        { type: 'cms_import', id: `tasks:${String(arg.id)}` },
        { type: 'cms_import', id: 'LIST' },
      ],
    },
    cmsImportSyncFromApi: {
      invalidatesTags: () => [{ type: 'cms_import', id: 'LIST' }],
    },
  },
});
